import styled from '@emotion/styled'
interface Props {
   direction: 'horizontal' | 'vertical'
   style: 'dashed' | 'solid' | 'gradient'
   className?: string
}

const SeparatorLine: React.FC<Props> = (props) => {
   const { direction, className, style } = props
   const classNames = `${className ?? ''} ${direction ?? ''} ${style ?? ''}`
   return <Line className={classNames} />
}

const Line = styled.div`
   &.horizontal {
      height: 2px;

      &.gradient {
         background: linear-gradient(
            to right,
            rgba(115, 115, 115, 0.05) 0%,
            #e1e1e1 50%,
            rgba(115, 115, 115, 0.05) 100%
         );
      }

      &.dashed {
         border-left: 2px dashed #d1d1d1;
      }

      &.solid {
         background-color: #d1d1d1;
      }
   }

   &.vertical {
      width: 2px;

      &.gradient {
         background: linear-gradient(
            to bottom,
            rgba(115, 115, 115, 0.05) 0%,
            #e1e1e1 50%,
            rgba(115, 115, 115, 0.05) 100%
         );
      }

      &.dashed {
         border-left: 2px dashed #d1d1d1;
      }

      &.solid {
         background-color: #d1d1d1;
      }
   }
`
export default SeparatorLine
